import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import $ from 'jquery';
import './hover-intent';

// max width that triggers mobile
const navigation_mobile = 768;

let isMobile = false;

let windowWidth = window.innerWidth;

let ScrollTriggered = false;

if ($('.navigation__secondary-standard-container')) { // check if the top nav bar exists

  const mediaQuery = gsap.matchMedia();

  mediaQuery.add('(min-width: 768px)', () => {

    let topNavHeight = $('.navigation__secondary-standard-container').innerHeight();

    const wpNavHeight = $('#wpadminbar').length > 0 ? $('#wpadminbar').innerHeight() : 0;

    topNavHeight -= wpNavHeight;

    const showTopMenuBar = gsap.from('.site-header', {
      y: -topNavHeight,
      paused: true,
      duration: 0.250,
    }).progress(1);


    $('.navigation__primary-header-mobile-search ').removeClass('active');
    $('.navigation__primary-header-mobile-search-bar .search__standard-wrapper').hide();

    ScrollTrigger.create({
      start: '100px top',
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1 ? showTopMenuBar.play() : showTopMenuBar.reverse();
      },
      onEnter: ({ progress, direction, isActive }) => {
        ScrollTriggered = true;
        $('.site-header').addClass('is-pinned');
      },
      onLeaveBack: ({ progress, direction, isActive }) => {
        ScrollTriggered = false;
        $('.site-header').removeClass('is-pinned');
      },
    });
    return () => { // make sure to clean up event listeners in the cleanup function!
      showTopMenuBar.play();
      ScrollTriggered = false;
    };
  });
}


$('.site-navigation-primary-header__nav .menu-list > li').hoverIntent({
  over: submenuDown,
  out: submenuUp,
  timeout: 250,
});


function submenuDown() {
  let subMenuItems = $(this)[0].querySelectorAll('ul > li');
  if (subMenuItems.length > 0) {
    var animation = gsap.fromTo(subMenuItems, { opacity: 0, y: 20 }, {
      opacity: 1,
      display: 'flex',
      y: 0,
      delay: .25,
      stagger: 0,
      paused: true,
    });
    animation.play();
    $(this).addClass('active');
  }
  if (!isMobile) {
    $('>.sub-menu, > .sub-menu', this).slideDown();
    $('>.sub-menu, > .sub-menu:before', this).slideDown();
  }
}

function submenuUp() {
  let subMenuItems = $(this)[0].querySelectorAll('ul > li');
  if (subMenuItems.length > 0) {
    $(this).removeClass('active');
  }
  if (!isMobile) {
    $('>.sub-menu, > .sub-menu', this).slideUp();
    $('>.sub-menu, > .sub-menu:before', this).slideUp();
  }
}

function toggleMobileMenus() {
  $('.site-navigation-primary-header__nav--mobile .menu-list .sub-menu').css('display', 'none');
  $('.site-navigation-primary-header__nav--mobile li.menu-item-has-children .submenu').css('display', 'none');
  $('.site-navigation-primary-header__nav--mobile li.menu-item-has-children').removeClass('active');
  if (!$('.site-navigation-primary-header__nav--mobile li.menu-item-has-children > div').hasClass('sub-menu-toggle')) {
    $('.site-navigation-primary-header__nav--mobile li.menu-item-has-children').append('<div class=\'sub-menu-toggle\'></div>');
  }

  // Search
  $('.navigation__primary-header-mobile-search').on('click', function (e) {
    if (isMobile) {
      $(this).toggleClass('active');
      $('.navigation__primary-header-mobile-search-bar > .search__standard-wrapper').slideToggle();
    }
  });

  // Hamburger
  $('.hamburger').on('click', function (e) {
    if (isMobile) {
      $(this).toggleClass('active');
      $('.site-navigation-primary-header__nav--mobile').slideToggle();
    }
  });
  // Sub Sub Menus
  $('.site-navigation-primary-header__nav--mobile .sub-menu-toggle').on('click', function (e) {
    if (isMobile) {
      $(this).closest('.site-navigation-primary-header__nav--mobile li.menu-item-has-children').children('.sub-menu').slideToggle(function () {
        $(this).closest('.site-navigation-primary-header__nav--mobile li.menu-item-has-children').toggleClass('active');
      });
      $(this).toggleClass('active');
    }
  });
}
toggleMobileMenus();

var sizing = debounce(function () {
  var scrollWidth = $('body').prop('scrollWidth') + 7;

  if (scrollWidth > navigation_mobile) {
    isMobile = false;
  } else {
    isMobile = true;
    if (windowWidth !== window.innerWidth) {
      windowWidth = window.innerWidth;
      $('.site-navigation-primary-header__nav--mobile .menu-list .sub-menu').css('display', 'none');
      $('.sub-menu-toggle').removeClass('active');
      $('.submenu').css('display', 'none');
      $('.site-navigation-primary-header__nav--mobile li.menu-item-has-children').removeClass('active');
      $('.site-navigation-primary-header__nav--mobile').css('display', 'none');
      $('.hamburger').removeClass('active');
    }
  }
}, 250);
sizing();

$(window).on('resize', sizing);

$('.site-header-bottom .icon-search').on('click', function (e) {
  if (isMobile === true) {
    $('.nav-search').slideToggle(250);
  }
});

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
